import React from 'react';

export const AdapterContext = React.createContext();
export const MeetingContext = React.createContext();
